import TEXTS from '../controller/TextVariables';
import Control from '../controller/Control';
import { useContext } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';

const DownloadControl = (props) => {
    const { map } = props;
    const { download } = TEXTS.controls;
    const className = 'download';
    const { showDownloadModal } = useContext(InterfaceContext);

    return (
        <Control
            map={map}
            className={className}
            clickHandler={() => {
                showDownloadModal();
            }}
        >
            <div>
                <button className="map-download" type="button" title={download.tooltip}>
                    <span className={'icon-download'}></span>Download
                </button>
            </div>
        </Control>
    );
};
export default DownloadControl;
